import { render, staticRenderFns } from "./AllocModal.vue?vue&type=template&id=751bb50c&"
import script from "./AllocModal.vue?vue&type=script&lang=js&"
export * from "./AllocModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports